import { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as TwitterIcon } from "feather-icons/dist/icons/twitter.svg";
import { ReactComponent as FacebookIcon } from "feather-icons/dist/icons/facebook.svg";
import { ReactComponent as InstagramIcon } from "feather-icons/dist/icons/instagram.svg";
import { ReactComponent as PhoneCallIcon } from "feather-icons/dist/icons/phone-call.svg";
import { ReactComponent as MailIcon } from "feather-icons/dist/icons/mail.svg";
import { ReactComponent as MapPinIcon } from "feather-icons/dist/icons/map-pin.svg";

const SectionContainer = styled.div`
  ${tw`relative bg-gray-200 py-16 overflow-hidden`}
`;

const ContentWrapper = tw.div`
  container mx-auto px-6 sm:px-12
`;

const ContactBlock = tw.div`
  flex flex-col lg:flex-row items-center lg:items-start bg-white rounded-lg shadow-lg p-8 md:p-12 gap-12 relative z-10
`;

const LeftPanel = styled.div`
  ${tw`lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left`}
`;

const RightPanel = tw.div`
  lg:w-1/2 w-full
`;

const Tagline = tw.p`
  text-red-500 text-xs font-bold uppercase tracking-wider mb-2
`;

const Heading = tw.h2`
  text-4xl sm:text-5xl font-black text-gray-800 leading-tight
`;

const Description = tw.p`
  text-gray-600 mt-4 leading-relaxed lg:pr-8
`;

const SocialIcons = tw.div`
  flex gap-x-4 mt-8
`;

const SocialLink = tw.a`
  w-10 h-10 rounded-full bg-gray-200 text-gray-700
  flex items-center justify-center
  hocus:bg-red-500 hocus:text-white transition duration-300
`;

const FormGrid = tw.div`
  grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4
`;

const Input = tw.input`
  px-4 py-3 bg-[#f7f2ee] border-none rounded focus:outline-none focus:ring-2 focus:ring-red-500
  text-gray-800 placeholder-gray-600
`;

const TextArea = styled.textarea`
  ${tw`
    px-4 py-3 bg-[#f7f2ee] border-none rounded focus:outline-none focus:ring-2 focus:ring-red-500
    text-gray-800 placeholder-gray-600 resize-none /* Allow resizing vertically */
  `}
  min-height: 160px; /* Ensure minimum height for the message area */
  ${tw`sm:col-span-2`}/* Span two columns on small screens and up */
`;

const SubmitButton = tw.button`
  mt-6 !bg-red-500 text-white px-8 py-3 rounded hover:bg-red-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-red-500
  w-full sm:w-auto /* Full width on small, auto width on larger */
`;

const ContactInfoContainer = styled.div`
  ${tw`flex flex-col sm:flex-row justify-around items-start md:items-center gap-8 mt-20 relative z-10`}

  /* Add the wavy line graphic between ContactBlock and ContactInfoContainer */
   /* This is complex CSS, best done with an SVG positioned here */
   /* Placeholder for the wavy line */
  ::before {
    content: "";
    ${tw`absolute left-0 right-0 top-[-60px] h-12 pointer-events-none`} /* Position it above */
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 120'%3E%3Cpath fill='none' stroke='%23d1d5db' stroke-width='2' stroke-dasharray='5,5' d='M0,60 Q360,0 720,60 T1440,60 Z'%3E%3C/path%3E%3C/svg%3E"); /* Simple dashed wave SVG */
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
`;

const InfoCard = tw.div`
  flex items-center gap-x-4 text-gray-700 flex-1 min-w-[200px] /* Flex-1 to distribute space, min-width to prevent cramming */
`;

const InfoIconWrapper = tw.div`
  w-12 h-12 bg-red-500 text-white rounded-full flex items-center justify-center flex-shrink-0
`;

const InfoText = tw.div`
  flex flex-col
`;

const InfoLabel = tw.p`
  text-gray-600 text-sm
`;

const InfoValue = tw.p`
  font-bold text-gray-800 mt-1
`;

// Small decorative dot, similar to the previous section
const DecorativeDot = styled.div`
  ${tw`absolute w-2 h-2 bg-red-500 rounded-full z-0`}
  top: 70%; /* Adjust position */
  right: 5%; /* Adjust position */
`;

export default () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = async (e) => {
    setIsSubmitting(true);
    e.preventDefault();
    fetch("https://tgnsystems.org/api/wealthwise/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        full_name: e.target.full_name.value,
        email: e.target.email.value,
        phone_number: e.target.phone_number.value,
        subject: e.target.subject.value,
        message: e.target.message.value,
      }),
    })
      .then((response) => {
        setIsSubmitting(false);
        console.log("response", response);
        if (response.status === 200) {
          alert("Message sent successfully!");
          e.target.reset();
        } else {
          alert("Failed to send message. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error.response);
        setIsSubmitting(false);
        alert("Message sent successfully!");
        e.target.reset();
      });
  };
  return (
    <SectionContainer id="contact">
      <ContentWrapper>
        <ContactBlock>
          <LeftPanel>
            {/* Decorative red circle outline handled by ::before in styled component */}
            <Tagline>|| CONTACT ||</Tagline>
            <Heading>Feel free to get in touch</Heading>
            <Description>
              <p>
                {" "}
                We can`t wait to hear from you, leave us your details and we
                will get back to you about anything you might be interested in.{" "}
              </p>
              <p>You can also engage us on our social media platforms.</p>
            </Description>
            <SocialIcons>
              <SocialLink href="/#">
                <TwitterIcon tw="w-5 h-5" />
              </SocialLink>
              <SocialLink href="/#">
                <FacebookIcon tw="w-5 h-5" />
              </SocialLink>
              <SocialLink href="/#">
                <InstagramIcon tw="w-5 h-5" />
              </SocialLink>
            </SocialIcons>
          </LeftPanel>

          <RightPanel>
            <form onSubmit={handleFormSubmit}>
              {" "}
              <FormGrid>
                <Input
                  type="text"
                  name="full_name"
                  required
                  placeholder="Full name"
                />
                <Input
                  type="email"
                  name="email"
                  required
                  placeholder="Email address"
                />
                <Input
                  type="tel"
                  name="phone_number"
                  required
                  placeholder="Phone number"
                />{" "}
                {/* Using type="tel" */}
                <Input
                  type="text"
                  name="subject"
                  required
                  placeholder="Subject"
                />
                <TextArea
                  required
                  name="message"
                  placeholder="Message"
                ></TextArea>{" "}
                {/* Textarea for the message */}
              </FormGrid>
              <SubmitButton type="submit">
                {isSubmitting ? "Sending..." : "Send a Message"}
              </SubmitButton>
            </form>
          </RightPanel>
        </ContactBlock>

        {/* Contact Info Section */}
        {/* Wavy line handled by ContactInfoContainer ::before */}
        <ContactInfoContainer>
          <InfoCard>
            <InfoIconWrapper>
              <PhoneCallIcon tw="w-6 h-6" /> {/* Phone Icon */}
            </InfoIconWrapper>
            <InfoText>
              <InfoLabel>Call Us on</InfoLabel>
              <InfoValue>
                <a href="tel:+256702003882">0702-003 882 | 0782-247 120</a>
              </InfoValue>
            </InfoText>
          </InfoCard>
          <InfoCard>
            <InfoIconWrapper>
              <MailIcon tw="w-6 h-6" /> {/* Mail Icon */}
            </InfoIconWrapper>
            <InfoText>
              <InfoLabel>Write us an email</InfoLabel>
              <InfoValue>
                <a href="mailto:godwin@wealthwise.co.ug">
                  godwin@wealthwise.co.ug
                </a>
              </InfoValue>
            </InfoText>
          </InfoCard>
          <InfoCard>
            <InfoIconWrapper>
              <MapPinIcon tw="w-6 h-6" /> {/* Location Icon */}
            </InfoIconWrapper>
            <InfoText>
              <InfoLabel>Visit our nearest Office</InfoLabel>
              <InfoValue>Nansana Heights room F-18, Hoima Road</InfoValue>
            </InfoText>
          </InfoCard>
        </ContactInfoContainer>

        {/* Decorative small red dot */}
        <DecorativeDot />
      </ContentWrapper>
      {/* Scroll to top button is likely a separate component */}
      {/* <ScrollToTopButton /> */}
    </SectionContainer>
  );
};
